import { render, staticRenderFns } from "./DecisionPointForm.vue?vue&type=template&id=67454990&"
import script from "./DecisionPointForm.vue?vue&type=script&lang=js&"
export * from "./DecisionPointForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports